import SviOglasiIkonica from './SviOglasiIkonica';
import AutoPlaceviIkonica from './AutoPlaceviIkonica';
import DodajOglasIkonica from './DodajOglasIkonica';
import KategorijeIkonica from './KategorijeIkonica';
import ZastupniciIkonica from './ZastupniciIkonica';
import ProdavniceIkonica from './ProdavniceIkonica';
import AutoOtpadiIkonica from './AutoOtpadiIkonica';
import ServisiIkonica from './ServisiIUslugeIkonica';
import MojiOglasiIkonica from './MojiOglasiIkonica';
import PorukeIkonica from './PorukeIkonica';
import SacuvaniOglasiIkonica from './SacuvaniOglasiIkonica';
import SacuvaniProfiliIkonica from './SacuvaniProfiliIkonica';
import SacuvanePretrageIkonica from './SacuvanePretrageIkonica';
import MarketingIkonica from './MarketingIkonica';
import MojProfilIkonica from './MojProfilIkonica';
import OdjaviMeIkonica from './OdjaviMeIkonica';
import OnlineUplataOglasa from './OnlineUplataOglasa';
import Logout from './Logout';

const iconMap = {
  home: SviOglasiIkonica,
  kategorije: KategorijeIkonica,
  dodajOglas: DodajOglasIkonica,
  ['auto-placevi']: AutoPlaceviIkonica,
  ['auto-saloni']: ZastupniciIkonica,
  prodavnice: ProdavniceIkonica,
  ['auto-otpadi']: AutoOtpadiIkonica,
  ['adresari']: ServisiIkonica,
  mojiOglasi: MojiOglasiIkonica,
  poruke: PorukeIkonica,
  sacuvaniOglasi: SacuvaniOglasiIkonica,
  sacuvaniProfili: SacuvaniProfiliIkonica,
  sacuvanePretrage: SacuvanePretrageIkonica,
  marketing: MarketingIkonica,
  mojProfil: MojProfilIkonica,
  odjaviMe: OdjaviMeIkonica,
  onlineUplata: OnlineUplataOglasa,
  logout: Logout,
};

export default iconMap;
